import { SubscriptionInvoice } from '@interfaces/general';
import { SUBSCRIPTION_TYPES_MAP } from '@utils/constants';

// Un pago con tarjeta puede confirmarse en Stripe (invoice paid, o intento en curso con
// reintentos) antes de que el backend sincronice tipo_plan (ver activatePendingPlan en
// plick-monorepo-backoffice). En esa ventana la cuenta sigue leyendo planId=FREEMIUM aunque
// el comercio acaba de pagar un plan — no se le debe mostrar "bienvenido a tu plan gratis"
// como si lo hubiera elegido a propósito. lastSuscriptionInvoice ya viaja en
// GET /v1/auth/account-details (ver Subscription.lastSuscriptionInvoice).
const hasPendingOrConfirmedPayment = (lastSuscriptionInvoice?: SubscriptionInvoice | null) => {
  if (!lastSuscriptionInvoice) return false;
  if (lastSuscriptionInvoice.status === 'paid') return true;
  if (lastSuscriptionInvoice.status === 'open' && (lastSuscriptionInvoice.attempt_count ?? 0) > 0) return true;
  return false;
};

export const shouldShowSubscriptionModal = (
  planId: keyof typeof SUBSCRIPTION_TYPES_MAP,
  lastSuscriptionInvoice?: SubscriptionInvoice | null,
) => {
  const flagKey = 'welcomeSubscriptionFlag';
  const modalSubscriptionFlag = localStorage.getItem(flagKey);

  const {
    FREEMIUM: { key: freemium },
    TRIAL: { key: trial },
  } = SUBSCRIPTION_TYPES_MAP;

  if (planId === freemium && hasPendingOrConfirmedPayment(lastSuscriptionInvoice)) {
    return false;
  }

  if (planId === freemium && modalSubscriptionFlag !== freemium) {
    localStorage.setItem(flagKey, freemium);
    return '/bienvenido-freemium';
  } else if (planId === trial && modalSubscriptionFlag !== trial) {
    localStorage.setItem(flagKey, trial);
    return '/bienvenido-prueba-gratis';
  }

  return false;
};
